<template>
  <v-col cols="12" class="text-center">
    <h1 class="display-1" v-html="title"></h1>
  </v-col>
<!--   <v-card flat class="transparent ch-card--header ch-post__meta grey lighten-5">
    <v-card-title class="primary--text" v-html="title"></v-card-title>
    <v-card-text v-if="description" v-html="description"></v-card-text>
  </v-card> -->
</template>

<script>
  export default {
    name: 'ArchiveHeader',

    props: ['title', 'description']
  }
</script>

<style lang="sass">
  .ch-card--header .v-card__title > span
    margin-left: 6px
</style>